
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ProductsPage = () => {
  const categories = [
    {
      name: 'Yangın Söndürücüler',
      description: 'Kuru kimyevi tozlu, köpüklü, CO₂ ve su bazlı yangın tüpleri',
      image: 'https://public.readdy.ai/ai/img_res/027220d7bded5625d0f24fe68664187f.jpg',
      productCount: '15+ Ürün',
    },
    {
      name: 'Yangın Dolapları',
      description: 'İç ve dış mekan yangın dolapları, çeşitli boyutlarda',
      image: 'https://readdy.ai/api/search-image?query=red%20fire%20cabinet%20with%20glass%20door%20mounted%20on%20clean%20white%20wall%20professional%20safety%20equipment%20modern%20design%20bright%20lighting&width=400&height=300&seq=prod2&orientation=landscape',
      productCount: '8+ Ürün',
    },
    {
      name: 'Yangın Hortumları',
      description: 'Yüksek basınca dayanıklı yangın hortumları ve makaraları',
      image: 'https://readdy.ai/api/search-image?query=red%20fire%20hose%20reel%20mounted%20on%20clean%20white%20wall%20professional%20firefighting%20equipment%20industrial%20safety%20bright%20studio%20lighting&width=400&height=300&seq=prod3&orientation=landscape',
      productCount: '6+ Ürün',
    },
    {
      name: 'Uyarı Levhaları',
      description: 'Fosforlu ve reflektif yangın güvenlik levhaları',
      image: 'https://readdy.ai/api/search-image?query=fire%20safety%20signs%20and%20warning%20labels%20collection%20on%20clean%20white%20background%20professional%20signage%20bright%20clear%20lighting&width=400&height=300&seq=prod4&orientation=landscape',
      productCount: '20+ Ürün',
    },
    {
      name: 'Yangın Battaniyeleri',
      description: 'Yağ ve elektrik yangınları için özel battaniyeler',
      image: 'https://readdy.ai/api/search-image?query=red%20fire%20blanket%20in%20protective%20case%20on%20clean%20white%20background%20professional%20safety%20equipment%20product%20photography&width=400&height=300&seq=prod5&orientation=landscape',
      productCount: '4+ Ürün',
    },
    {
      name: 'Duman Dedektörleri',
      description: 'Kablosuz ve kablolu duman algılama sistemleri',
      image: 'https://readdy.ai/api/search-image?query=white%20smoke%20detector%20alarm%20on%20clean%20background%20modern%20fire%20safety%20device%20professional%20product%20photography%20bright%20lighting&width=400&height=300&seq=prod6&orientation=landscape',
      productCount: '5+ Ürün',
    },
  ];

  const featuredProducts = [
    {
      name: '6 Kg ABC Tozlu Yangın Tüpü',
      category: 'Yangın Söndürücüler',
      description: 'A-B-C sınıfı yangınlar için ideal, ofis ve ev kullanımına uygun',
      features: ['TSE Sertifikalı', '5 Yıl Garanti', 'Kolay Kullanım'],
    },
    {
      name: '12 Kg ABC Tozlu Yangın Tüpü',
      category: 'Yangın Söndürücüler',
      description: 'Fabrika ve büyük işletmeler için yüksek kapasiteli yangın tüpü',
      features: ['TSE Sertifikalı', '5 Yıl Garanti', 'Yüksek Kapasite'],
    },
    {
      name: '50 Litre Köpüklü Yangın Tüpü',
      category: 'Yangın Söndürücüler',
      description: 'A-B sınıfı yangınlar için profesyonel çözüm',
      features: ['TSE Sertifikalı', 'Endüstriyel Kullanım', 'Yüksek Verim'],
    },
    {
      name: '5 Kg CO₂ Yangın Tüpü',
      category: 'Yangın Söndürücüler',
      description: 'Elektrik panoları ve hassas ekipmanlar için ideal',
      features: ['TSE Sertifikalı', 'Kalıntı Bırakmaz', 'Elektrik Güvenli'],
    },
    {
      name: 'İç Mekan Yangın Dolabı 70x50x25',
      category: 'Yangın Dolapları',
      description: 'Cam kapaklı, yangın tüpü ve ekipman saklama dolabı',
      features: ['Sağlam Yapı', 'Cam Kapak', 'Kolay Montaj'],
    },
    {
      name: 'Dış Mekan Yangın Dolabı 90x70x30',
      category: 'Yangın Dolapları',
      description: 'Hava koşullarına dayanıklı, metal kapaklı yangın dolabı',
      features: ['Hava Koşullarına Dayanıklı', 'Metal Kapak', 'Geniş Hacim'],
    },
    {
      name: '30 Metre Yangın Hortumu',
      category: 'Yangın Hortumları',
      description: 'Yüksek basınca dayanıklı, makaralı yangın hortumu',
      features: ['Yüksek Dayanıklılık', 'Kolay Kullanım', 'Uzun Ömürlü'],
    },
    {
      name: 'Acil Çıkış Levhası Fosforlu',
      category: 'Uyarı Levhaları',
      description: 'Karanlıkta parlayan acil çıkış yönlendirme levhası',
      features: ['Fosforlu', 'Uzun Ömürlü', 'Kolay Montaj'],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Ürünlerimiz
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliği için ihtiyacınız olan tüm ürünler ve ekipmanlar
            </p>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl text-dark-900 mb-4">
              Ürün Kategorileri
            </h2>
            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
              Geniş ürün yelpazemizle yangın güvenliği ihtiyaçlarınıza çözüm sunuyoruz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {categories.map((category, index) => (
              <div
                key={index}
                className="bg-white border-2 border-dark-100 rounded-xl overflow-hidden hover:border-primary-500 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img 
                    src={category.image} 
                    alt={category.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="font-display font-semibold text-xl text-dark-900">
                      {category.name}
                    </h3>
                    <span className="text-sm text-primary-600 font-medium whitespace-nowrap">
                      {category.productCount}
                    </span>
                  </div>
                  <p className="text-dark-600 text-sm mb-4">
                    {category.description}
                  </p>
                  <button className="text-primary-600 font-semibold flex items-center group-hover:translate-x-2 transition-transform whitespace-nowrap">
                    <span>Ürünleri Gör</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl text-dark-900 mb-4">
              Öne Çıkan Ürünler
            </h2>
            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
              En çok tercih edilen ve popüler ürünlerimiz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
            {featuredProducts.map((product, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 border-2 border-dark-100 hover:border-primary-500 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="mb-4">
                  <span className="text-xs text-primary-600 font-medium bg-primary-50 px-3 py-1 rounded-full whitespace-nowrap">
                    {product.category}
                  </span>
                </div>
                <h3 className="font-display font-semibold text-lg text-dark-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {product.name}
                </h3>
                <p className="text-dark-600 text-sm mb-4">
                  {product.description}
                </p>
                <div className="space-y-2 mb-4">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-sm text-dark-600">
                      <i className="ri-check-line text-primary-600 mr-2"></i>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                <button className="w-full bg-primary-600 text-white py-2.5 rounded-lg font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap">
                  Teklif Al
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Ürünlerimiz Hakkında Bilgi Alın
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Size en uygun ürünleri seçmenizde yardımcı olmak için bizimle iletişime geçin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              İletişime Geç
            </Link>
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-dark-900 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-800 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Hemen Ara</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsPage;
